module.exports = __webpack_public_path__ + "static/media/wurth.743f1218.svg";